import * as React from 'react'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import PageTransition from 'gatsby-plugin-page-transitions'

// defaultStyle starts at opacity:1 so SSR/initial HTML is visible to crawlers.
// The plugin's own default starts at 0 and animates in after JS mounts, which
// hides content from non-JS crawlers even though it is in the DOM.
const index = <Props extends Record<string, any>>(Component: React.FC<Props>) => (props: Props) => {
  return (
    <PageTransition
      defaultStyle={{ transition: 'opacity 250ms ease-in-out', opacity: 1 }}
      transitionStyles={{
        entering: { opacity: 1 },
        entered: { opacity: 1 },
        exiting: { opacity: 0 },
      }}
    >
      <Component {...props} />
    </PageTransition>
  )
}

export default index
